import { getCurrencyConfig } from './currencyConfig';

export const formatCurrency = (amount) => {
  const { code, locale, symbol } = getCurrencyConfig();
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(amount ?? 0);
  } catch {
    // Fallback: manual symbol + formatted number
    return `${symbol}${Number(amount ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
};

export const formatDate = (date) => new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });

export const getStatusColor = (status) => {
  const map = {
    active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    inactive: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    suspended: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    confirmed: 'bg-medihub-light text-medihub-secondary dark:bg-medihub-dark dark:text-medihub-highlight',
    completed: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    cancelled: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    placed: 'bg-medihub-light text-medihub-secondary dark:bg-medihub-dark dark:text-medihub-highlight',
    approved: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300',
    'out-for-delivery': 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    delivered: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    'in-stock': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    'low-stock': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    'out-of-stock': 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    failed: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    refunded: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
  };
  return map[status] || 'bg-gray-100 text-gray-800';
};

export const exportToCSV = (data, filename) => {
  if (!data.length) return;
  const headers = Object.keys(data[0]).join(',');
  const rows = data.map(row => Object.values(row).map(v => `"${v}"`).join(','));
  const csv = [headers, ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = `${filename}.csv`; a.click();
  URL.revokeObjectURL(url);
};

export const paginate = (data, page, perPage) => {
  const start = (page - 1) * perPage;
  return { data: data.slice(start, start + perPage), total: data.length, pages: Math.ceil(data.length / perPage) };
};
